<template>
  <div class="account">
    <div class="infomation" v-if="userInfo.ext_info">
      <div style="margin-left: 47px">
        <img
          :src="userInfo.ext_info.avatars[3]"
          style="margin-bottom: 10px"
          alt
          width="72"
          v-if="userInfo.ext_info.avatars.length>0"
        />
        <div class="avatar-100" v-else>
          {{userInfo.name.substring(userInfo.name.length-2)}}
        </div>
        <br/>
        <div style="clear:both;margin-left:30px;font-size: 14px;color: #016FFF;cursor: pointer;">
          <span v-trace-click="'n.3387.6051.0'" @click="dialogVisible = true">修改头像</span>
          <uploadAvatar :dialogVisible.sync="dialogVisible"></uploadAvatar>
        </div>
      </div>
      <div class="num-line"> </div>
      <div class="num">
        <span>登录账号 <span style="margin-left: 64px;">{{userInfo.email}}</span></span>
        <span>信息变更
          <span class="item" style="margin-left: 64px;width: 110px">
              <router-link to="/modifyTel">修改手机号</router-link>
          </span>
          <span class="item" style="width: 153px">
            <span>
              <router-link to="/passport" v-trace-click="'n.3387.7192.0'">绑定passport账号</router-link>
            </span>
          </span>
        </span>
      </div>
    </div>
    <div class="prompt">您的安全服务</div>
    <div class="prompt-content">密码的有效期为90天，建议您定期及时更换密码，以免影响登录。</div>
    <a :href="pathConfig.retrievePath" style="margin-bottom:30px;">修改密码</a>

    <div class="prompt">查看个人权限</div>
    <a :href="pathConfig.myPermission" target="_blank">我的权限</a>
  </div>
</template>

<script>
import uploadAvatar from "@/components/uploadAvatar.vue";
import { mapGetters } from "vuex";
import pathConfig from "@/config/requirePath";
export default {
  name: "add",
  components: {
    uploadAvatar
  },
  data() {
    return {
      dialogVisible: false,
      pathConfig
    };
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {},
  created() {
    console.log('pathConfig',pathConfig)

  }
};
</script>

<style lang="scss" scoped>
a {
  color: #1989fa;
}
.infomation {
  height: 140px;
  background-color: #f8f8f8;
  display: flex;
  align-items: center;
  img {
    margin-left: 20px;
    border-radius: 50%;
  }
  .avatar-100 {
    margin-left: 20px;
    width: 72px;
    height: 72px;
    border-radius: 50px;
    background-color: #1990ff;
    text-align: center;
    line-height: 72px;
    color: #FFFFFF;
    font-size: 18px;
    font-family: "Microsoft YaHei";
    letter-spacing: 0;

  }
  .name {
    height: 60px;
    padding: 0 40px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    font-size: 18px;
    .portrait {
      cursor: pointer;
      color: #1989fa;
      font-size: 14px;
    }
  }
  .num-line {
    margin-left: 80px;
    height: 100px;
    width: 1px;
    background: #DEE2E7;
  }
  .num {
    height: 100px;
    padding-left: 40px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    span {
      line-height: 26px;
    }
    .item {
      height: 32px;
      margin-left: 20px;
      background: #E9F2FF;
      display:-moz-inline-box;
      display:inline-block;
      line-height:32px;
      font-size: 14px;
      text-align:center
    }
  }
}
.prompt {
  color: #333333;
  font-size: 18px;
  margin: 30px 0 10px;
}
.prompt-content {
  margin-bottom: 10px;
}
</style>
